import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="934884489582-4logkq2nh414npcv1tkvtrs8cplnonlb.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
);
